<template>
  <div id="app">
    <router-view></router-view>
    
    <div v-if="user != null"> 
         <!-- user buttons -->
        <div v-if="user.vendor == null" id="userBtns" class="btn-group btn-group-justified bottom-btns">
          <a @click="openPage('Omiljenisalon')" href="/user#Omiljenisalon" class="btn bottom-btn bottom-book"><i class="far fa-heart"></i>
              <p>Omiljeni</p>
          </a>
          <a href="/" class="btn bottom-btn bottom-call"><i class="fas fa-search"></i>
              <p>Pretraži</p>
          </a>
          <!--
          <a @click="openPage('Mojerezervacije')" href="/vendor#Mojerezervacije" class="btn bottom-btn bottom-mail"><i class="far fa-calendar-check"></i>
              <p>Rezervacije</p>
          </a>
          -->
          <a @click="openPage('postavke')" href="/user#postavke" class="btn bottom-btn bottom-mail"><i class="fa fa-cog"></i>
              <p>Postavke</p>
          </a>
          <a @click="openPage('Mojikomentari')" href="/user#Mojikomentari" class="btn bottom-btn bottom-whatsapp"><i class="far fa-comments"></i>
						<p>Komentari</p>
          </a>
        </div>

          <!-- biz-user-btns -->
          <!--
        <div v-if="user.vendor != null" id="bizUserBtns" class="btn-group btn-group-justified bottom-btns">
            -->
            <!--   
            <a :href="'/salon/'+user.salon.name" class="btn bottom-btn bottom-book"><i class="fas fa-home"></i>
                <p>Početna</p>
            </a>-->
            <!--
            <router-link :to="'/salon/'+user.salon.name+'#salon-usluge'" class="btn bottom-btn bottom-mail"><i class="fas fa-plus"></i>
                <p>Novi termin</p>
            </router-link>
            
            <a @click="openPage('terminiNav')" href="/vendor#terminiNav" class="btn bottom-btn bottom-mail"><i class="far fa-calendar-check"></i>
                <p>Rezervacije</p>
            </a>
            <a @click="openPage('raspored')" href="/vendor#raspored" class="btn bottom-btn bottom-call"><i class="far fa-calendar-alt"></i>
                <p>Raspored</p>
            </a>
            <a @click="openPage('komentari')" href="/vendor#komentari" class="btn bottom-btn bottom-whatsapp"><i class="far fa-comments"></i>
                <p>Komentari</p>
            </a>
        </div>
-->
    </div>
  </div>
</template>

<script> 
import { mapState } from 'vuex';

export default {
  name: 'App', 
  data(){
    return { 
    }
  },
  computed:{
    ...mapState({
      user:(state)=>state.user, 
    })
  },
  methods:{
    openPage(page){
      document.getElementById(page).click();
    },
  },
  created(){ 
    var data=localStorage.getItem('data');
    if(data != null){
      data=JSON.parse(data);
      this.$store.commit('setUser',data);
      this.$store.dispatch('get',this.$store.state.endpoint+'get-user?token='+this.$store.state.token)
      .then((result)=>{
        // console.log(result); 
        this.$store.commit('setUser',{user:result.data,token:data.token});
        // console.log(this.user);
      })
      .catch((error)=>{
        console.log(error.request)
      });
    }
  }
}
</script> 
